import ControllerBoard from '@/components/Controller-Board/Page'
export default [
    {
      path: '/controller-board/:pageCode',
      name: 'controller-board',
      props: true,
      component: ControllerBoard
    }
]